<template>
    <div :class="[companyClass, canScroll]" v-loading="pageLoading" element-loading-text="Loading..."
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
        v-show="userPermissionsFilter.xoomreports">
        <div class="page-table column mb-20" :class="{ 'flex': !isMobile, 'overflow': isMobile }">
            <div class="page-header">
                <h1 class="pageTitle">Xoom Cash Transactions Report</h1>
                <h4>partners &amp; agents</h4>
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                    <el-breadcrumb-item>reports</el-breadcrumb-item>
                    <el-breadcrumb-item>xoom cash transactions</el-breadcrumb-item>
                    <el-breadcrumb-item>xoom cash transactions</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <resize-observer @notify="handleResize" />
            <div class="table-responsive">
                <table class="table" id="datatable" style="color:white;">
                    <thead>
                        <tr>
                            <th>Ref Number</th>
                            <th>Status</th>
                            <th>Paid By</th>
                            <th>Paid On</th>
                            <th>Sender Name</th>
                            <th>Sender Type</th>
                            <th>Sender Phone</th>
                            <th>Sender Country</th>
                            <th>Sender City</th>
                            <th>Sender Currency</th>
                            <th>Sender Amount</th>
                            <th>Transaction Date</th>
                            <th>Reason</th>
                            <th>Receiver Name</th>
                            <th>Receiver Type</th>
                            <th>Receiver Country</th>
                            <th>Receiver Address</th>
                            <th>Receiver Currency</th>
                            <th>Receiver Amount</th>
                            <th>Receiver ID</th>
                            <th>Receiver Mobile</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in transactionsdata" :key="item.userID">
                            <td>{{ item.referenceNumber }}</td>
                            <td>{{ item.transactionStatus }}</td>
                            <td>{{ item.payerName }}</td>
                            <td>{{ formatShortDate(item.paidOutDate) }}</td>
                            <td>{{ item.senderName }}</td>
                            <td>{{ item.senderType }}</td>
                            <td>{{ item.senderPhoneNumber }}</td>
                            <td>{{ item.senderCountry }}</td>
                            <td>{{ item.senderCity }}</td>
                            <td>{{ item.senderCurrency }}</td>
                            <td>{{ formatPrice(item.senderAmount) }}</td>
                            <td>{{ formatShortDate(item.tranDate) }}</td>
                            <td>{{ item.transactionReason }}</td>
                            <td>{{ item.revieverName }}</td>
                            <td>{{ item.receiverType }}</td>
                            <td>{{ item.receiverCountry }}</td>
                            <td>{{ item.receiverAddress }}</td>
                            <td>{{ item.receiverCurrency }}</td>
                            <td>{{ formatPrice(item.receiverAmount) }}</td>
                            <td>{{ item.receiverIdNumber }}</td>
                            <td>{{ item.receiverPhoneNumber }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';

import users from '@/assets/data/USERS_MOCK_DATA.json'
import moment from 'moment-timezone'
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';
var now = new Date();
export default {
    name: 'XoomCashReport',
    data: function () {
        return {
            partner: '',
            partnername: '0',
            partnerId: '3',
            search: '0',
            fromdate: this.prevMonthDate(),
            todate: this.currentDate(),
            transactionsdata: '',

            //IdProfile = "data:image/png;base64," + response.data;
        }
    },
    methods: {
        fromDateChanged(e) {
            if (!this.fromdate) this.fromdate = e;
        },
        toDateChanged(e) {
            if (!this.todate) this.todate = e;
        },
        currentDate() {
            const current = new Date();
            const date = `${current.getFullYear()}-${("0" + (current.getMonth() + 1)).slice(-2)}-${("0" + (current.getDate())).slice(-2)}`;
            return date;
        },
        prevMonthDate() {
            const current = new Date();
            return moment(current).subtract(1, 'months').format('YYYY-MM-DD');
        },
        refreshCompanies() {
            this.startLoader("Loading Page...");
            this.getxoomCashPaidMisMatch()
                .then((result) => {
                    //this.tableRefreshed(result);
                    $("#datatable").dataTable().fnDestroy();
                    this.transactionsdata = result.items;
                    this.$nextTick(function () {
                        this.initDt()
                    });
                    this.stopLoader();
                }).catch(err => {
                    this.errorMessage("An Error Occured. " + err);
                    //this.tableRefreshed(this.defaultListResult);
                    this.stopLoader();
                });
        },
        initDt() {
            var cmp = this.loggedInCompany.name + " Partner Transactions";
            var cmp_logo = this.loggedInCompany.logo;
            $('#datatable').DataTable({
                dom: 'Blfrtip',
                buttons: [
                    {
                        extend: 'pdfHtml5',
                        title: function () {
                            return cmp;
                        },
                        orientation: 'landscape',
                        pageSize: 'A2', // You can also use "A1","A2" or "A3", most of the time "A3" works the best.
                        customize: function (doc) {
                            doc.defaultStyle.fontSize = 11; //2, 3, 4,etc
                            doc.styles.tableHeader.fontSize = 10; //2, 3, 4, etc
                            //doc.content[1].table.widths = Array(doc.content[1].table.body[0].length + 1).join('*').split('');
                        },
                        text: '<i class="fa fa-file-pdf-o"> PDF</i>',
                        titleAttr: 'PDF',
                        messageBottom: 'This report was generated By ' + this.loggedInUser,
                    }
                ]
            });
        },
    },

    created() {
        this.getLoggedInCompany();
        this.refreshCompanies();
    },
    mixins: [PermissionsMixins]
}
</script>

<style>
table.dataTable tbody tr,
.dataTables_length select,
.dataTables_length select option {
    background-color: #191d24;
}

table.dataTable {
    margin-left: 0px;
    text-align: left;
}

.dataTables_filter label,
.dataTables_wrapper .dataTables_filter input,
.dataTables_length select,
.dataTables_length label {
    color: white !important;
}

.dataTables_wrapper .dataTables_filter input ::placeholder,
.dataTables_wrapper .dataTables_filter input ::-ms-input-placeholder {
    color: white !important;
}

.dataTables_wrapper .dataTables_paginate a.paginate_button {
    color: white !important;
}

.table thead tr,
.table .tbody,
.table .tbody tr {
    white-space: nowrap;
}

.table thead tr th {
    padding: 5px 17px;
    padding-left: 5px;
    background-color: #1b1f27;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.4);
}
</style>